import React from "react";
import styled from "styled-components";

import viewIcon from "../assets/view.svg";

interface ButtonProps {
  width: number;
  height: number;
  color: string;
}

const ViewButton = (props: any) => {
  const { className, width, height, label, color, onClick, children } = props;
  return (
    <Button
      className={className}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
    >
      <img src={viewIcon} alt="logo-nike" />
      <span>{label}</span>
      {children}
    </Button>
  );
};

const Button = styled.button<ButtonProps>`
  width: ${(p) => `${p.height}px`};
  height: ${(p) => `${p.height}px`};
  background: ${(p) => p.color};
  border-radius: ${(p) => `${p.height / 2}px`};
  font-family: HelveticaNeue-Medium;
  font-size: 22px;
  color: #ffffff;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  border-color: transparent;
  -webkit-transition: width 0.6s;
  transition: width 0.3s;
  display: flex;
  align-items: center;

  img {
    width: 27px;
    height: 22px;
    margin: 0 2px;
  }

  span {
    margin-left: 6px;
    font-size: 12px;
    color: #fbfbfb;
    overflow: hidden;
  }
`;

export default ViewButton;
